// Bridges the axios response interceptor (configureAxiosAuth, in ./auth.js —
// plain JS that runs outside React) to the React tree for the account_archived
// lockout. Same shape as ./seatLock.js, for the same reason.
//
// Login itself now refuses an archived account (Users::SessionsController), so
// nobody can newly sign in to one. This path exists for the session that was
// ALREADY open when an admin archived the account: jwt_blacklists has no
// user_id column, so there is no way to revoke a specific user's live tokens,
// and their JWT stays valid for up to 24 hours. The API gate refuses them data
// (410 account_archived) but without this signal the app just renders a
// silently broken shell of spinners and empty panels until the token expires.
//
// A per-request redirect (the account_read_only / feature_unavailable pattern
// next to this one in auth.js) is wrong here for the same reason it was wrong
// for seat_limit_exceeded: the 410 fires on reads as well as writes, so every
// page would bounce, and there is nowhere useful to send them — the whole
// account is frozen, billing included.
let listeners = [];

export const notifyAccountArchived = (payload) => {
  listeners.slice().forEach((fn) => fn(payload));
};

export const subscribeAccountArchived = (fn) => {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
};
